<template>
  <div class="container">
    <Header />
    <div>
      <FullMap
        v-if="MapData && curMap == 0"
        :areaCode="MapData.areaCode"
        :mapData="MapData.mapData"
        :legendConf="MapData.legendConf"
        :itemList="MapData.itemList"
      />

      <Poimap v-if="curMap == 1" :poiData="MapData.poiData"/>
      <Heatmap v-if="curMap == 2" :heatmapData="MapData.heatmapData" />
      <Gridmap v-if="curMap == 3" :gridData="MapData.heatmapData" :opacity="0.6"/>

      <MapTitle :data="mapTitleData" @getCurTab="setCurtab"/>

      <div class="left-content">
        <BScroll>
          <div>
            <BasePanel code="401" title="旅游业态资源分析">
              <YetaiZiyuanFenxi
                :chartData="YetaiZiyuanFenxiData"
                v-if="YetaiZiyuanFenxiData.length > 0"
              />
            </BasePanel>
            <BasePanel code="402" title="酒店资源分析">
              <JiudianZiyuanFenxi
                :chartData="JiudianZiyuanFenxiData"
                v-if="JiudianZiyuanFenxiData.length > 0"
              />
            </BasePanel>
            <BasePanel code="403" title="景区资源分析"
              ><JingquZiyuanFenxi
                :chartData="JingquZiyuanFenxiData"
                v-if="JingquZiyuanFenxiData.length > 0"
            /></BasePanel></div
        ></BScroll>
      </div>
      <div class="right-content">
        <BScroll
          ><div>
            <BasePanel code="404" title="交通通达性分析">
              <JiaotongTongdaFenxi
                :chartData="JiaotongTongdaFenxiData"
                v-if="JiaotongTongdaFenxiData"
              />
            </BasePanel>
            <BasePanel code="405" title="购物商圈分析">
              <GouwuShangquanFenxi
                :chartData="GouwuShangquanFenxiData"
                v-if="GouwuShangquanFenxiData"
              />
            </BasePanel>
            <BasePanel title="娱乐资源分析">
              <YuleZiyuanFenxi
                :chartData="YuleZiyuanFenxiData"
                v-if="YuleZiyuanFenxiData.length > 0"
              />
            </BasePanel></div
        ></BScroll>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Common/Header.vue";
import MapTitle from '@/components/Common/MapTitle.vue'
import BScroll from "@/components/Common/BScroll.vue";
import BasePanel from "@/components/Common/BasePanel.vue";
import YetaiZiyuanFenxi from "@/components/ZiyuanPinggu/YetaiZiyuanFenxi.vue";
import JiudianZiyuanFenxi from "@/components/ZiyuanPinggu/JiudianZiyuanFenxi.vue";
import JingquZiyuanFenxi from "@/components/ZiyuanPinggu/JingquZiyuanFenxi.vue";
import YuleZiyuanFenxi from "@/components/ZiyuanPinggu/YuleZiyuanFenxi.vue";
import GouwuShangquanFenxi from "@/components/ZiyuanPinggu/GouwuShangquanFenxi.vue";
import JiaotongTongdaFenxi from "@/components/ZiyuanPinggu/JiaotongTongdaFenxi.vue";
import FullMap from "@/components/FullMap.vue";
import Poimap from "@/components/Loca/Poimap.vue";
import Heatmap from "@/components/Loca/Heatmap.vue";
import Gridmap from "@/components/Loca/Gridmap.vue";

export default {
  name: "ZiyuanPinggu",
  components: {
    Header,
    MapTitle,
    BasePanel,
    BScroll,
    YetaiZiyuanFenxi,
    JiudianZiyuanFenxi,
    JingquZiyuanFenxi,
    YuleZiyuanFenxi,
    GouwuShangquanFenxi,
    JiaotongTongdaFenxi,
    FullMap,
    Poimap,
    Heatmap,
    Gridmap
  },
  data() {
    return {
      mapTitleData: {
        title: '',
        tab: ['资源概况', '资源点图', '资源热图', '资源网格']
      },
      MapData: null,
      curMap: 0,
      mapTitle: '',
      YetaiZiyuanFenxiData: [],
      JiudianZiyuanFenxiData: [],
      JingquZiyuanFenxiData: [],
      JiaotongTongdaFenxiData: null,
      GouwuShangquanFenxiData: null,
      YuleZiyuanFenxiData: []
    };
  },
  mounted() {
    // 请求地图数据
    fetch("/data/ZiyuanPinggu/MapData.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.MapData = json.data;
        this.mapTitleData.title = json.data.title;
      });
    // 请求业态资源分析
    fetch("/data/ZiyuanPinggu/YetaiZiyuanFenxi.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.YetaiZiyuanFenxiData = json.data;
      });
    // 请求酒店资源分析
    fetch("/data/ZiyuanPinggu/JiudianZiyuanFenxi.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.JiudianZiyuanFenxiData = json.data;
      });
    // 请求景区资源分析
    fetch("/data/ZiyuanPinggu/JingquZiyuanFenxi.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.JingquZiyuanFenxiData = json.data;
      });
    // 请求交通通达分析
    fetch("/data/ZiyuanPinggu/JiaotongTongdaFenxi.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.JiaotongTongdaFenxiData = json.data;
      });
    // 请求购物商圈分析
    fetch("/data/ZiyuanPinggu/GouwuShangquanFenxi.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.GouwuShangquanFenxiData = json.data;
      });
    // 请求娱乐资源分析
    fetch("/data/ZiyuanPinggu/YuleZiyuanFenxi.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.YuleZiyuanFenxiData = json.data;
      });
  },
  methods: {
    setCurtab(val) {
      this.curMap = val
    }
  }
};
</script>
<style scoped lang="less"></style>
